import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../routes/Routes';
import { useEVChargerStore } from '../../../../hooks/useEVChargerStore';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { parseZodErrors, stringFieldSchema } from '@utils';
import { SELECT_OPTIONS_ERROR } from '../../../../constants/errors';

export const IsHazardousPage = () => {
  const navigate = useNavigate();
  const {
    update,
    data: { isHazardous },
  } = useEVChargerStore();
  const [result, setResult] = useState(isHazardous);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title =
    'Is the EV charging point hazardous or has it caused an injury?';

  const handleChange = (option: string) => {
    setResult(option as 'Yes' | 'No');
    setErrorMessages([]);
  };

  const options = [
    {
      labelText: 'Yes',
      isDefault: isHazardous === 'Yes',
      isLabelBold: false,
    },
    {
      labelText: 'No',
      isDefault: isHazardous === 'No',
      isLabelBold: false,
    },
  ];

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.BEFORE_YOU_START),
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'isHazardous',
          SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          isHazardous: result,
        });
        if (validatedData.isHazardous) {
          update('isHazardous', validatedData.isHazardous as 'Yes' | 'No');
        }
        if (result === 'Yes') {
          navigate(RoutesList.CALL_US);
        } else if (result === 'No') {
          navigate(RoutesList.PROVIDER_SELECTION);
        }
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  return (
    <BinaryQuestionTemplate
      title={title}
      options={options}
      errorPath={'isHazardous'}
      errorMessages={errorMessages}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
